__turbopack_context__.v({
  "contentWrapper": "NqS4vW_contentWrapper",
  "footerContainer": "NqS4vW_footerContainer",
  "leftSide": "NqS4vW_leftSide",
  "logoWrap": "NqS4vW_logoWrap",
  "mainBox": "NqS4vW_mainBox",
  "rightSide": "NqS4vW_rightSide",
  "sectionHeader": "NqS4vW_sectionHeader",
  "styledLinks": "NqS4vW_styledLinks",
});
